import { sendPost } from "src/utils/sendApi";

export const woUploadReportApi = sendPost("v1/data/wo_reports/upload")

export const woRetrieveReportApi = sendPost("v1/data/wo_reports/retrieve")

export const woDeleteReportApi = sendPost("v1/data/wo_reports/delete")
